/* ---------------------------------------------------------------------
 *                            Import Packages
 * --------------------------------------------------------------------- */

// Yup
import * as yup from "yup";

// Common
import { validate } from "./common";

/* ---------------------------------------------------------------------
 *                           Data Validity Schema
 * --------------------------------------------------------------------- */

/**
 * 定义短信登录的验证规则
 * @type {yup.ObjectSchema}
 */
const messageLoginSchema = yup.object().shape({
    mobile: yup
        .string()
        .required("手机号不能为空")
        .matches(/^1[3-9]\d{9}$/, "请输入有效的手机号"),
    smsCode: yup
        .string()
        .required("验证码不能为空")
        .matches(/^\d{4}$/, "验证码必须为4位数字"),
});

/**
 * 定义密码登录的验证规则
 * @type {yup.ObjectSchema}
 */
const passwordLoginSchema = yup.object().shape({
    mobile: yup
        .string()
        .required("手机号不能为空")
        .matches(/^1[3-9]\d{9}$/, "请输入有效的手机号"),
    password: yup
        .string()
        .required("密码不能为空")
        .matches(/^[A-Za-z0-9]{6,15}$/, "密码仅限英文和数字，长度为6~15位"),
});


/**
 * 定义重置密码的验证规则
 * @type {yup.ObjectSchema}
 */
const resetPasswordSchema = yup.object().shape({
    mobile: yup
        .string()
        .required("手机号不能为空")
        .matches(/^1[3-9]\d{9}$/, "请输入有效的手机号"),
    smsCode: yup
        .string()
        .required("验证码不能为空")
        .matches(/^\d{4}$/, "验证码必须为4位数字"),
    newPwd: yup
        .string()
        .required("新密码不能为空")
        .matches(/^[A-Za-z0-9]{6,15}$/, "密码仅限英文和数字，长度为6~15位"),
});

/**
 * 定义注册的验证规则
 * @type {yup.ObjectSchema}
 */
const registerSchema = yup.object().shape({
    mobile: yup
        .string()
        .required("手机号不能为空")
        .matches(/^1[3-9]\d{9}$/, "请输入有效的手机号"),
    smsCode: yup
        .string()
        .required("验证码不能为空")
        .matches(/^\d{4}$/, "验证码必须为4位数字"),
    password: yup
        .string()
        .required("密码不能为空")
        .matches(/^[A-Za-z0-9]{6,15}$/, "密码仅限英文和数字，长度为6~15位"),
});


/* ---------------------------------------------------------------------
 *                          Data Validity Functions
 * --------------------------------------------------------------------- */

/**
 * 验证短信登录数据
 * @param {object} data - 短信登录数据 
 * @returns {object} - 验证结果
 */
function validateMessageLogin(data) {
    return validate(data, messageLoginSchema);
}

/**
 * 验证密码登录数据
 * @param {object} data - 密码登录数据 
 * @returns {object} - 验证结果
 */
function validatePasswordLogin(data) {
    return validate(data, passwordLoginSchema);
}

/**
 * 验证重置密码表单数据
 * @param {object} data - 忘记密码表单数据 
 * @returns {object} - 验证结果
 */
function validateResetPassword(data) {
    return validate(data, resetPasswordSchema);
}

/**
 * 验证注册表单数据
 * @param {object} data - 注册表单数据 
 * @returns {object} - 验证结果
 */
function validateRegister(data) {
    return validate(data, registerSchema);
}

export {
    validateRegister,
    validateMessageLogin,
    validatePasswordLogin,
    validateResetPassword
}